"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageUrl = exports.useImage = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const Auth_1 = __importDefault(require("@opsbase/react-useauth/Auth"));
const axios_1 = __importDefault(require("axios"));
function useImage() {
    return {
        getImageUrl: exports.getImageUrl,
        getFullImageUrlById,
        getFullImageUrlByFileName,
        getThumbnailImageUrl,
    };
}
exports.useImage = useImage;
exports.default = useImage;
const getFullImageUrlById = id => {
    const fullImageId = getThumbnailKey(id).replace('_thumbnail', '');
    return axios_1.default
        .get(`${lib_env_1.default.apis.images}/imageUrl/${fullImageId}`, {
        headers: Object.assign(Object.assign({}, Auth_1.default.getRequestAuthHeaders()), { Accepts: 'application/json' }),
    })
        .then(r => r.data.toString());
};
const getFullImageUrlByFileName = fileName => {
    const fullImageId = fileName.replace('_thumbnail', '');
    return axios_1.default
        .get(`${lib_env_1.default.apis.images}/imageUrl/${fullImageId}`, {
        headers: Object.assign(Object.assign({}, Auth_1.default.getRequestAuthHeaders()), { Accepts: 'application/json' }),
    })
        .then(r => r.data.toString());
};
const getThumbnailImageUrl = id => {
    const thumbnailKey = getThumbnailKey(id);
    return axios_1.default
        .get(`${lib_env_1.default.apis.images}/imageUrl/${thumbnailKey}`, {
        headers: Object.assign(Object.assign({}, Auth_1.default.getRequestAuthHeaders()), { Accepts: 'application/json' }),
    })
        .then(r => r.data.toString());
};
const getImageUrl = fileName => {
    if (!fileName)
        return undefined;
    return axios_1.default
        .get(`${lib_env_1.default.apis.images}/imageUrl/${fileName}`, {
        headers: Object.assign(Object.assign({}, Auth_1.default.getRequestAuthHeaders()), { Accepts: 'application/json' }),
    })
        .then(r => r.data.toString());
};
exports.getImageUrl = getImageUrl;
const getThumbnailKey = function (key) {
    // get extension and filename without extension
    const fileExtension = key.split('.').pop();
    const fileNameWithoutExtn = key.substr(0, key.lastIndexOf('.'));
    // build thumbnail key
    let thumbnailKey;
    if (fileNameWithoutExtn) {
        thumbnailKey = fileNameWithoutExtn + '_thumbnail.' + fileExtension;
    }
    else {
        thumbnailKey = key + '_thumbnail';
    }
    return thumbnailKey;
};
